import { Link } from 'react-router-dom';
import { GraduationCap, Play, Compass, MessageSquare, ArrowRight } from 'lucide-react';
import MarketingShell from '../components/homepage/MarketingShell';

const RESOURCES = [
  {
    icon: Play, color: '#FF7816', title: 'Watch the Demo',
    desc: 'See CountBucks in action — accounting, AI chat, documents and invoicing in one quick tour.',
    href: '/demo', cta: 'Watch Demo',
  },
  {
    icon: GraduationCap, color: '#27B84A', title: 'CountBucks University',
    desc: 'Step-by-step lessons inside the app that teach you bookkeeping, reports and AI workflows as you go.',
    href: '/login?mode=register&plan=starter&cadence=monthly', cta: 'Start Learning Free',
  },
  {
    icon: Compass, color: '#3B82F6', title: 'Guided Tours',
    desc: 'Interactive in-app walkthroughs for every major feature — from your first invoice to bank reconciliation.',
    href: '/login', cta: 'Log In to Explore',
  },
  {
    icon: MessageSquare, color: '#8B5CF6', title: 'Talk to Us',
    desc: 'Questions before you start? Real humans (and real CPAs) answer — usually within one business day.',
    href: '/contact', cta: 'Contact Support',
  },
];

export default function ResourcesHub() {
  return (
    <MarketingShell title="Resources | CountBucks">
      <section className="mx-auto max-w-7xl px-4 pb-20 pt-14 sm:px-6" data-testid="resources-hub-page">
        <span className="inline-block rounded-full border border-[#27B84A]/40 bg-[#F2FBF4] px-4 py-1.5 text-xs font-bold tracking-widest text-[#118A35] dark:bg-[#0E1A11] dark:text-[#27B84A]">
          RESOURCES
        </span>
        <h1 className="mt-5 max-w-3xl text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
          Learn it fast. <span className="text-[#27B84A]">Run it yourself.</span>
        </h1>
        <p className="mt-4 max-w-2xl text-base text-[#596273] sm:text-lg dark:text-[#AEB6B1]">
          Everything you need to get comfortable with CountBucks — videos, guided lessons and real human help.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2">
          {RESOURCES.map((r) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`resource-card-${r.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                className="flex flex-col rounded-3xl border border-[#E4E8E6] bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/5 dark:border-[#1C2420] dark:bg-[#10150F]"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${r.color}1A` }}>
                  <Icon className="h-6 w-6" style={{ color: r.color }} />
                </span>
                <h2 className="mt-4 text-xl font-bold">{r.title}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-[#596273] dark:text-[#8B948F]">{r.desc}</p>
                <Link to={r.href} className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#118A35] transition-colors hover:text-[#27B84A] dark:text-[#27B84A]">
                  {r.cta} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </section>
    </MarketingShell>
  );
}
